// src/components/properties/PropertiesHero/PropertiesHero.jsx
import React from "react";
import { motion } from "framer-motion";
import { FiHome, FiMapPin, FiShield, FiArrowUpRight } from "react-icons/fi";
import "./PropertiesHero.css";

export default function PropertiesHero() {
  return (
    <section className="ph">
      <div className="ph__bg" aria-hidden="true" />
      <div className="ph__overlay" aria-hidden="true" />

      <div className="container ph__container">
        <motion.div
          className="ph__content"
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55, ease: "easeOut" }}
        >
          {/* Breadcrumb */}
          <div className="ph__crumbs">
            <a href="/" className="ph__crumb">
              Home
            </a>
            <span className="ph__sep">/</span>
            <span className="ph__crumb ph__crumb--active">Properties</span>
          </div>

          <h1 className="ph__title">Find Your Next Property</h1>
          <p className="ph__sub">
            Explore verified listings across top locations. Clean details, smart
            filters, and a smooth path from browsing to booking.
          </p>

          {/* Quick chips */}
          <div className="ph__chips">
            <span className="ph__chip">
              <FiShield /> Verified Listings
            </span>
            <span className="ph__chip">
              <FiMapPin /> Prime Locations
            </span>
            <span className="ph__chip">
              <FiHome /> Homes & Apartments
            </span>
          </div>

          {/* CTA row */}
          <div className="ph__actions">
            <button className="ph__btn ph__btn--primary" type="button">
              Browse Listings <FiArrowUpRight />
            </button>

            <button className="ph__btn ph__btn--ghost" type="button">
              Talk to an Agent
            </button>
          </div>
        </motion.div>
      </div>

      {/* subtle bottom fade so filter bar looks attached */}
      <div className="ph__bottomFade" aria-hidden="true" />
    </section>
  );
}
